import balancerAbi from './balancerABI';
import crpABI from './crpABI';
import erc20ABI from './erc20ABI';
import vaultABI from './vaultABI';
import { vestingABI } from './vestingABI';

const abis = {
    balancer: balancerAbi,
    erc20: erc20ABI,
    CRP: crpABI,
    vault: vaultABI,
    vesting: vestingABI,
};

export default abis;
